import React from 'react';
import type { ViewKind } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
import { ViewItemIcon } from '@jira/polaris__component-icons/src/iconForPolarisFieldType.tsx';
import { EmojiWrapper } from '@jira/polaris__lib-emoji-wrapper/src/EmojiWrapper.tsx';
import { useEmoji } from '@jira/polaris__lib-emoji-picker/src/useEmoji.tsx';
import { cssMap } from '@atlaskit/css';
import Emoji from '@atlaskit/emoji/emoji';
import { Box } from '@atlaskit/primitives/compiled/box';

type Props = {
	isReadOnly: boolean;
	emojiId: string | undefined;
	viewKind: ViewKind | string | undefined;
};

const styles = cssMap({
	polarisIconWrapper: {
		display: 'flex',
		alignItems: 'center',
	},
});

export const TitleIconResolver = (props: Props): React.JSX.Element => {
	const { emojiId, viewKind } = props;

	const emoji = useEmoji(emojiId);

	if (emoji) {
		return (
			<EmojiWrapper>
				<Emoji emoji={emoji} fitToHeight={18} showTooltip />
			</EmojiWrapper>
		);
	}

	return (
		<Box xcss={styles.polarisIconWrapper}>
			<ViewItemIcon viewKind={viewKind} />
		</Box>
	);
};

export default TitleIconResolver;
